import React from "react";

const getPersonName = (
  firstName,
  middleName,
  lastName,
  props,
  showNameReverse = false
) => {
  const name = showNameReverse
    ? `${lastName}, ${firstName}`
    : `${firstName} ${middleName} ${lastName}`;
  return (
    <span
      role="button"
      tabIndex={0}
      onClick={() =>
        props.handleNewSearchClick(this, "Person", name, {
          firstname: firstName,
          middlename: middleName,
          lastname: lastName,
        })
      }
      className={"url-link"}
    >
      {name}
    </span>
  );
};

export default getPersonName;



// WEBPACK FOOTER //
// ./src/components/common/Name.js